// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getDatabase } from 'firebase/database';
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyA13Xh9kLl1bLllZAf5_DunX3_h0Gi2vYc",
  authDomain: "waseem-68ec4.firebaseapp.com",
  databaseURL: "https://waseem-68ec4-default-rtdb.firebaseio.com",
  projectId: "waseem-68ec4",
  storageBucket: "waseem-68ec4.firebasestorage.app",
  messagingSenderId: "655817547288",
  appId: "1:655817547288:web:e5302249064d78a5bcad6d"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize Firebase storage


export { db, auth, storage };

